import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'
import { waterOutline } from 'ionicons/icons'
import type { DateTime } from 'luxon'
import { formatCompactRelativeTime } from '../../../helpers/datetime'
import { DetailWithIcon } from './DetailWithIcon'

/** "Concrete Time" detail (pour time), compact like Depart: 7AM. */
export const ConcreteTimeDetail = ({
  concreteAt,
  datetime,
}: {
  concreteAt: DateTime | undefined
  datetime: DateTime | undefined
}) => {
  const { _ } = useLingui()
  if (!concreteAt) return null
  return (
    <DetailWithIcon
      icon={waterOutline}
      header={_(msg`Concrete Time`)}
      body={formatCompactRelativeTime(concreteAt, datetime)}
    />
  )
}
